import React, { useEffect, useState } from 'react';

import LazyImage from '@swf/components/LazyImage/LazyImage';
import IcnSquare from '@swf/core/assets/casino/icnSquare.jpg';
import useRequest from '@swf/core/hooks/useRequest';
import type { CasinoGame, StreamData } from '@swf/core/types/CasinoGame';

import styles from './CMSCarousel.scss';
import CarouselSlider from './CarouselSlider';

interface Props {
  autoRotate: boolean;
  slideSpeed: number;
  withHeading: boolean;
}

const CasinoGamesCarousel: React.FC<Props> = ({ autoRotate, slideSpeed, withHeading }) => {
  const request = useRequest();
  const [casinoGames, setCasinoGames] = useState<CasinoGame[]>([]);

  useEffect(() => {
    request<StreamData<CasinoGame>>({
      service: 'casino.games.all.stream',
      body: {
        pg: 0,
        psz: 4,
        qry: [
          {
            formalparamcode: 'tagname',
            values: ['Slots'],
            operand: 1,
            join: 1,
            dynamic: false
          }
        ],
        ims: { tags: ['icnSquare'] },
        grp: true,
        tgs: true,
        patch: false,
        order: [{ column: 'numOf', sort: 1 }]
      }
    }).subscribe(({ body: { games } }) => {
      if (games.length > 0) {
        setCasinoGames(games);
      }
    });
  }, [request]);

  return (
    <CarouselSlider
      autoRotate={autoRotate}
      className="center"
      responsive={[
        {
          breakpoint: 725,
          settings: {
            slidesToShow: 1
          }
        }
      ]}
      slideSpeed={slideSpeed}
      withHeading={withHeading}
    >
      {casinoGames.map((game, key) => {
        const src = game.images.icnSquare || '';
        const props = { src, className: '' };
        const fallbackElem = <img {...props} alt={game.name} src={IcnSquare} />;

        return (
          <div key={key} className={styles.casinoGameContainer}>
            {src === '' && <div className={styles.iconLabel}>{game.name}</div>}
            <LazyImage {...props} fallback={fallbackElem} loader={fallbackElem} alt={game.name} />
          </div>
        );
      })}
    </CarouselSlider>
  );
};

export default CasinoGamesCarousel;
